/**
 * Narrow an API string into the invoice display unions.
 *
 * The invoice endpoints type `status` and `type` as plain `string` — nothing
 * constrains them to the four/three values `InvoiceCard` renders. Casting at
 * the call sites would have silenced the compiler while leaving a new backend
 * status to reach a component that has no branch for it.
 *
 * `undefined` is already a member of both unions, so an unrecognised value
 * degrades to exactly the state the card already handles: no chip, rather than
 * a wrong one.
 */
// Mirrors the DB enum in `1596404895249_invoice_schema`, plus 'subscribe',
// which the invoices page offers as a filter. Narrowing against a SHORTER list
// than the backend emits does not protect anything — it just blanks the column.
const INVOICE_STATUSES = ['unpaid', 'failed', 'pending', 'canceled', 'delivered', 'expired', 'refunded', 'paid', 'new'] as const
const INVOICE_TYPES = ['purchase', 'subscribe', 'recharge', 'refund', 'registration'] as const

export const toInvoiceStatus = (value: string | null | undefined): InvoiceStatus =>
	INVOICE_STATUSES.includes(value as typeof INVOICE_STATUSES[number]) ? (value as InvoiceStatus) : undefined

export const toInvoiceType = (value: string | null | undefined): InvoiceType =>
	INVOICE_TYPES.includes(value as typeof INVOICE_TYPES[number]) ? (value as InvoiceType) : undefined
